import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollPosition } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { checkoutMutations } from '@as-react/common-queries';
import { RoutePathname } from '@as-react/common-types';
import { useMutation } from '@tanstack/react-query';
import { ButtonAlpha, Sidebar, useDebounce, useMediaQueryMatchesOnDesktop, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DELAY } from '../../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';
import { useOAuth } from '../../../../hooks/useOAuth';
import { makeGetBasketMappedProductsState } from '../../../../redux/basket/selectors/BasketSelector';
export const ProceedCheckoutCTA = ({ disabled }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { defaultRequestParams, servicesEndpoint, root } = useAemConfig();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isMobile = useMediaQueryMatchesOnMobile();
    const [isSidebarHidden, setIsSidebarHidden] = useState(true);
    const [buttonPosition, setButtonPosition] = useState(0);
    const [clientHeight, setClientHeight] = useState(0);
    const [proceedButton, setProceedButton] = useState();
    const { authUrl, isLoggedIn } = useOAuth({ returnTo: `${root}buy.html`, flow: 'checkout' });
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { init } = checkoutMutations({ servicesEndpoint, defaultRequestParams });
    const { mutate: initCheckoutMutation, data: initCheckoutData, isPending, isError, isSuccess } = useMutation(init);
    const products = useSelector(makeGetBasketMappedProductsState());
    const isDisabled = disabled || isPending || (!isError && isSuccess);
    const updatePosition = () => {
        if (proceedButton) {
            const top = proceedButton.getBoundingClientRect().top + proceedButton.getBoundingClientRect().height + window.pageYOffset;
            setButtonPosition(top);
        }
    };
    const handleSetHidden = () => {
        const isHiddenStickyBar = proceedButton && proceedButton.getBoundingClientRect().bottom < window.innerHeight;
        setIsSidebarHidden(Boolean(isHiddenStickyBar));
    };
    const proceedButtonRef = useCallback((node) => {
        if (node !== null) {
            setProceedButton(node);
        }
    }, []);
    const updateWithDelay = useDebounce(() => {
        setClientHeight(window.innerHeight);
        updatePosition();
    }, DELAY.DELAY_20);
    const onClickCheckout = () => __awaiter(void 0, void 0, void 0, function* () {
        initCheckoutMutation();
    });
    useEffect(() => {
        if (initCheckoutData === null || initCheckoutData === void 0 ? void 0 : initCheckoutData.readyForCheckout) {
            const hrefCheckout = `${root}buy.html`;
            if (isNewAuth && !isLoggedIn) {
                window.location.href = authUrl;
            }
            if (isLoggedIn) {
                window.location.href = `${hrefCheckout}/${RoutePathname.DELIVERY}`;
            }
            else {
                window.location.href = hrefCheckout;
            }
        }
    }, [initCheckoutData]);
    useEffect(() => {
        updatePosition();
    }, [proceedButton, products.length, isMobile, isDesktop]);
    useEffect(() => {
        updatePosition();
        window.addEventListener('resize', updateWithDelay);
        return () => window.removeEventListener('resize', updatePosition);
    }, []);
    useEffect(() => {
        handleSetHidden();
    }, [buttonPosition, clientHeight]);
    useScrollPosition(handleSetHidden, [buttonPosition]);
    return (_jsxs(_Fragment, { children: [_jsx(ButtonAlpha, { fullWidth: true, innerRef: proceedButtonRef, theme: "branded", testId: "checkout_button", state: isDisabled ? 'disabled' : undefined, onClick: onClickCheckout, children: t('checkout.basket.order') }), !isDesktop && !isSidebarHidden && (_jsx(Sidebar, { isOpen: true, side: "right", align: "bottom", position: "fixed", animation: "none", zIndex: "sticky", hasCloseBtn: false, hasBackdrop: false, fullHeight: false, customWidth: "100%", children: _jsx(ButtonAlpha, { fullWidth: true, theme: "branded", testId: "checkout_button", state: isDisabled ? 'disabled' : undefined, onClick: onClickCheckout, children: t('checkout.basket.order') }) }))] }));
};
